module.exports = __webpack_public_path__ + "static/media/en-flag.95cf2213.svg";